<template>
    <div class="row text-left form--items">

        <!-- Loading -->
        <div class="col-12 text-center" v-if="loading">
            <i class="fas fa-spinner fa-2x fa-spin mb-2"></i>
            <p>Estamos processando seu pagamento...</p>
        </div>

        <!-- Error -->
        <div class="col-12 text-center" v-else-if="statusPayment !== 1 ">
            <lottie-animation
                    path="./static/lottie/error.json"
                    :loop="false"
                    :autoPlay="true"
                    :width="150"
                    :height="150"
            />
            <p>Erro ao processar pagamento.</p>
            <p>{{ errorMessage }}</p>
            <p class="my-3">
                <button class="btn btn-primario" @click="back()">
                    Voltar
                </button>
                <button class="btn btn-primario" @click="tryAgain()">
                    Tentar novamente
                </button>
            </p>
        </div>

        <!-- Canceled -->
         <div class="col-12 text-center" v-else-if="statusPayment === 6 ">
            <lottie-animation
                path="./static/lottie/error.json"
                :loop="false"
                :autoPlay="true"
                :width="150"
                :height="150"
            />
            <p>Pagamento cancelado.</p>
            <p class="my-3">
                <button class="btn btn-primario" @click="back()">
                    Voltar
                </button>
                <button class="btn btn-primario" @click="tryAgain()">
                    Tentar novamente
                </button>
            </p>
        </div>

        <!-- Pagamento em cartão aprovado -->
        <div class="col-12" v-else-if="statusPayment == 1  && !boleto.barcode">
            <lottie-animation
                    path="./static/lottie/sucess.json"
                    :loop="false"
                    :autoPlay="true"
                    :width="150"
                    :height="150"
            />
            <p class="text-center">
                Parabéns, seu pagamento foi processado e seu produto foi ativado com sucesso!
            </p>
            <div class="w-100 text-center mt-4">
                <button class="btn btn-primario" @click="$emit('goDashboard')">
                    Ir pra o painel
                </button>
            </div>
        </div>

        <!-- Boleto gerado -->
        <div class="col-12" v-else-if="statusPayment == 1  && boleto.barcode">
            <lottie-animation
                    path="./static/lottie/sucess.json"
                    :loop="false"
                    :autoPlay="true"
                    :width="150"
                    :height="150"
            />
            <p>
                Boleto gerado com sucesso!
            </p>
            <p>
                Você tem 3 dias para pagar. O pagamento é aprovado em
                até 2 dias úteis
            </p>

            <p class="label--boleto mb-2">
                Numeração do código de barras
            </p>
            <input id="boleto" class="d-none" :value="normalizeBoleto" >
            <p v-if="boleto.barcode">{{ normalizeBoleto }}</p>
            <p class="text-center my-4">
                <button class="btn btn-primario" @click="copyCode">
                    Copiar código
                </button>
                <a
                    :href="boleto.url"
                    target="_blank"
                    class="link--boleto"
                >
                    <button class="btn btn-primario">
                        Imprimir boleto
                    </button>
                </a>
            </p>

            <p class="text-center">
                <span class="mt-2 " v-if="copySucceeded">{{
                    copySucceeded
                }}</span>
            </p>

            <div class="w-100 text-center mt-4">
                <p class="text-center my-4">
                    <a @click="$emit('goDashboard')" class="link--boleto cursor-pointer">Ir para o painel</a>
                </p>
            </div>
        </div>

    </div>
</template>

<script>
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";

export default {
    name: "Result",
    data: () => {
        return {
			copySucceeded: "",
            errors: {},
        }
    },
    components: {
        LottieAnimation,
    },
    props: {
        loading:{
            required: true,
        },
        statusPayment:{
            required: true,
        },
        errorMessage:{
            required: true,
        },
        boleto:{
            required: true,
        },
    },
    computed:{
        normalizeBoleto() {
            let barcode = this.boleto.barcode;
            return barcode;
        },
    },
    methods:{
        back(){
            this.$emit('back')
        },
        tryAgain(){
            this.$emit('tryAgain')
        },
        copyCode() {
            var copyText = document.getElementById("boleto");
            copyText.select();
            copyText.setSelectionRange(0, 99999);
            navigator.clipboard.writeText(copyText.value);
            this.copySucceeded = "Código copiado!";
            setTimeout(() => {
                this.copySucceeded = "";
            }, 1500);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/organisms/CheckoutStepResult.vue